import styled from "styled-components";

export const StyledVariantListItemWrapper = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 5px;
`;
export const StyledVariantListItemTopWrapper = styled.div`
  /* border: 1px solid #f0f0f0;
  border-bottom-width: 0; */
  padding: 1.6rem;
  /* border-radius: 5px; */
`;
export const StyledVariantListItemTopInputAndButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
  align-items: center;

  .input-wrapper {
    width: 100%;
  }
  .button-wrapper {
    display: flex;
    gap: 1rem;
  }
`;
export const StyledVariantListItemChildrenWrapper = styled.div`
  background-color: #fafafa;
  /* border: 1px solid #f0f0f0;
  border-top-width: 0; */
  padding: 1.6rem;
  .text-description {
    font-size: 14px;
    color: #1c1726;
    margin-bottom: 1.6rem;
  }
`;
